module.exports = __webpack_public_path__ + "static/media/fair-selected.417b85e8.svg";